import React from 'react'

import PropTypes from 'prop-types'

import './testimonial.css'

const Testimonial = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="testimonial-max-width thq-section-max-width">
        <div className="testimonial-container10">
          <h2 className="thq-heading-2">{props.heading1}</h2>
          <span className="testimonial-text11 thq-body-small">
            {props.content1}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div data-animated="true" className="thq-card testimonial-card1">
                <div className="testimonial-container12">
                  <img
                    alt={props.author1Alt}
                    src={props.author1Src}
                    className="testimonial-image1"
                  />
                  <div className="testimonial-container13">
                    <strong className="thq-body-large">
                      {props.author1Name}
                    </strong>
                    <span className="thq-body-small">
                      {props.author1Position}
                    </span>
                  </div>
                </div>
                <span className="testimonial-text14 thq-body-small">
                  {props.review1}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div data-animated="true" className="thq-card testimonial-card2">
                <div className="testimonial-container14">
                  <img
                    alt={props.author2Alt}
                    src={props.author2Src}
                    className="testimonial-image2"
                  />
                  <div className="testimonial-container15">
                    <strong className="thq-body-large">
                      {props.author2Name}
                    </strong>
                    <span className="thq-body-small">
                      {props.author2Position}
                    </span>
                  </div>
                </div>
                <span className="testimonial-text17 thq-body-small">
                  {props.review2}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div data-animated="true" className="thq-card testimonial-card3">
                <div className="testimonial-container16">
                  <img
                    alt={props.author3Alt}
                    src={props.author3Src}
                    className="testimonial-image3"
                  />
                  <div className="testimonial-container17">
                    <strong className="thq-body-large">
                      {props.author3Name}
                    </strong>
                    <span className="thq-body-small">
                      {props.author3Position}
                    </span>
                  </div>
                </div>
                <span className="testimonial-text20 thq-body-small">
                  {props.review3}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div data-animated="true" className="thq-card testimonial-card4">
                <div className="testimonial-container18">
                  <img
                    alt={props.author4Alt}
                    src={props.author4Src}
                    className="testimonial-image4"
                  />
                  <div className="testimonial-container19">
                    <strong className="thq-body-large">
                      {props.author4Name}
                    </strong>
                    <span className="thq-body-small">
                      {props.author4Position}
                    </span>
                  </div>
                </div>
                <span className="testimonial-text23 thq-body-small">
                  {props.review4}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial.defaultProps = {
  author3Name: 'Michael Davis',
  author4Src:
    'https://images.unsplash.com/photo-1494176547405-ccd4eff6df3d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTc5Njk2Nnw&ixlib=rb-4.0.3&q=80&w=1080',
  author4Alt: 'Image of Sarah Thompson',
  author2Alt: 'Image of Emily Johnson',
  author4Name: 'Sarah Thompson',
  author1Alt: 'Image of John Smith',
  author3Src:
    'https://images.unsplash.com/photo-1615433886063-57c17bbfb989?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTc5Njk2Nnw&ixlib=rb-4.0.3&q=80&w=1080',
  author3Alt: 'Image of Michael Davis',
  author2Name: 'Emily Johnson',
  author1Position: 'CEO, ABC Company',
  author2Src:
    'https://images.unsplash.com/photo-1579169233264-1f7866d3a890?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTc5Njk2Nnw&ixlib=rb-4.0.3&q=80&w=1080',
  content1:
    'Cloud Desk has transformed our business operations with their expert Salesforce solutions. Our team is more efficient and productive than ever before.',
  author1Src:
    'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyOTc5Njk2Nnw&ixlib=rb-4.0.3&q=80&w=1080',
  review4:
    'Working with Cloud Desk has been a game-changer for us. Their expertise in Salesforce automation has streamlined our processes and saved us valuable time and resources.',
  author2Position: 'CFO, XYZ Corporation',
  review2:
    'Power BI implementation by Cloud Desk has revolutionized our data analysis process. We now have real-time insights that help us make informed decisions quickly.',
  review3:
    'Oracle CX solutions provided by Cloud Desk have significantly improved our customer experience. Our clients are happier, and our sales have seen a noticeable boost.',
  author4Position: 'COO, PQR Industries',
  author3Position: 'CTO, LMN Enterprises',
  review1:
    'We are extremely satisfied with the services provided by Cloud Desk. Their team is knowledgeable, responsive, and always goes above and beyond to meet our needs.',
  author1Name: 'John Smith',
  heading1: 'Client Testimonials',
}

Testimonial.propTypes = {
  author3Name: PropTypes.string,
  author4Src: PropTypes.string,
  author4Alt: PropTypes.string,
  author2Alt: PropTypes.string,
  author4Name: PropTypes.string,
  author1Alt: PropTypes.string,
  author3Src: PropTypes.string,
  author3Alt: PropTypes.string,
  author2Name: PropTypes.string,
  author1Position: PropTypes.string,
  author2Src: PropTypes.string,
  content1: PropTypes.string,
  author1Src: PropTypes.string,
  review4: PropTypes.string,
  author2Position: PropTypes.string,
  review2: PropTypes.string,
  review3: PropTypes.string,
  author4Position: PropTypes.string,
  author3Position: PropTypes.string,
  review1: PropTypes.string,
  author1Name: PropTypes.string,
  heading1: PropTypes.string,
}

export default Testimonial
